export default "__VITE_ASSET__DiDreIbq__"